export let CartApiTags = /*#__PURE__*/function (CartApiTags) {
  CartApiTags["cart"] = "#cartA";
  CartApiTags["updateLineItems"] = "#updateLineItems";
  CartApiTags["removeLineItem"] = "#removeLineItem";
  CartApiTags["applyActions"] = "#applyActions";
  return CartApiTags;
}({});
//# sourceMappingURL=premium-cart.types.js.map